import { RowGroup } from '../types';
import type { RowModel } from './row-model';

export class RowGroupModel {
  public readonly isRowGroup: boolean = true;

  readonly id: string;
  readonly data: RowGroup;
  readonly rows: RowModel[];

  public isExpanded: boolean = true;

  constructor(group: RowGroup, rows: RowModel[]) {
    this.id = group.id;
    this.data = group;
    this.rows = rows;
  }

  public static empty() {
    return new RowGroupModel({ id: '' }, []);
  }
}
